<template>
  <div class="lista-projetos">
    <header class="topo">
      <div>
        <h2>Projetos</h2>
        <p>Pesquise e acompanhe a execução das iniciativas.</p>
      </div>
      <RouterLink :to="{ name: 'gestao-projetos.novo' }" class="botao-primario">
        + Criar projeto
      </RouterLink>
    </header>

    <section class="filtros-container">
      <div class="filtros-header">
        <div>
          <h3>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
              />
            </svg>
            Filtros de busca
          </h3>
          <p>Use os campos abaixo para refinar sua pesquisa</p>
        </div>
        <button type="button" class="filtros-clear" @click="limparFiltros">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
          Limpar filtros
        </button>
      </div>

      <div class="filtros-grid">
        <div class="filtro-campo">
          <label>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
              />
            </svg>
            Buscar por título
          </label>
          <div class="filtro-input-wrapper">
            <input
              id="pesquisa"
              v-model="busca"
              type="text"
              placeholder="Digite parte do nome"
              class="form-input"
              @input="filtrarLocal"
            />
          </div>
        </div>

        <div class="filtro-campo">
          <label>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <circle
                cx="12"
                cy="10"
                r="3"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
            Município
          </label>
          <div class="filtro-input-wrapper">
            <ComboboxMunicipio
              ref="filtroMunicipio"
              :filter="municipioFiltro"
              class="combobox-municipio"
              clearable
              @changeCity="aoAlterarMunicipio"
            />
          </div>
        </div>
      </div>

      <div class="filtros-grid-secondary">
        <div class="filtro-campo">
          <label>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
              />
            </svg>
            Situação
          </label>
          <div class="filtro-input-wrapper">
            <select
              id="filtro-situacao"
              v-model="filtros.situacao"
              class="form-select"
            >
              <option value="">Todas</option>
              <option
                v-for="situacao in opcoes.situacoes"
                :key="situacao"
                :value="situacao"
              >
                {{ situacao }}
              </option>
            </select>
          </div>
        </div>

        <div class="filtro-campo">
          <label>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zM4 8v1h16V8h-4.37l-.73-1.26C14.37 6.28 13.72 6 13 6h-2c-.72 0-1.37.28-1.9.74L8.37 8H4zm2.5-4C8.01 4 9 4.99 9 6.5S8.01 9 6.5 9 4 8.01 4 6.5 4.99 4 6.5 4z"
              />
            </svg>
            Área Chave
          </label>
          <div class="filtro-input-wrapper">
            <select
              id="filtro-area-chave"
              v-model="filtros.areaChave"
              class="form-select"
            >
              <option value="">Todas</option>
              <option v-for="area in areasChave" :key="area" :value="area">
                {{ area }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </section>

    <!-- Listagem de Projetos com Vuetify -->
    <v-container fluid class="pa-4 lista-background">
      <!-- Data Table para Desktop -->
      <v-card class="mb-6 d-none d-md-block desktop-card" elevation="8">
        <v-card-title
          class="d-flex align-center justify-space-between pa-6 card-header"
        >
          <div class="d-flex align-center">
            <div>
              <h2 class="text-h5 font-weight-bold text-primary mb-1">
                Projetos Cadastrados
              </h2>
              <p class="text-body-2 text-medium-emphasis ma-0">
                Acompanhe a execução das iniciativas municipais
              </p>
            </div>
          </div>
          <v-chip
            v-if="projetosFiltrados.length"
            color="success"
            variant="elevated"
            prepend-icon="mdi-chart-line"
            size="large"
            class="count-chip"
          >
            {{ projetosFiltrados.length }} projeto{{
              projetosFiltrados.length !== 1 ? "s" : ""
            }}
          </v-chip>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="projetosFiltrados"
          :loading="carregando"
          loading-text="Carregando projetos..."
          no-data-text="Nenhum projeto encontrado"
          item-value="idProjeto"
          class="elevation-0"
          :items-per-page="10"
          :items-per-page-options="[5, 10, 25, 50]"
        >
          <!-- Slot para o título do projeto -->
          <template v-slot:item.titulo="{ item }">
            <div class="py-3">
              <div class="text-body-1 font-weight-medium text-primary mb-1">
                {{ item.titulo }}
              </div>
            </div>
          </template>

          <!-- Slot para município -->
          <template v-slot:item.nomeMunicipio="{ item }">
            <div class="d-flex align-center">
              <v-icon
                icon="mdi-map-marker"
                size="small"
                class="me-2 text-medium-emphasis"
              ></v-icon>
              <span>{{ item.nomeMunicipio || "—" }}</span>
            </div>
          </template>

          <!-- Slot para prioridade -->
          <template v-slot:item.prioridade="{ item }">
            <v-chip
              :color="getPrioridadeColor(item.prioridade)"
              variant="elevated"
              size="small"
              :prepend-icon="getPrioridadeIcon(item.prioridade)"
            >
              {{ item.prioridade || "Não definida" }}
            </v-chip>
          </template>

          <!-- Slot para status/situação -->
          <template v-slot:item.situacao="{ item }">
            <v-chip
              :color="getStatusColor(item.situacao)"
              variant="elevated"
              size="small"
              :prepend-icon="getStatusIcon(item.situacao)"
            >
              {{ item.situacao || "Não definido" }}
            </v-chip>
          </template>

          <!-- Slot para ações -->
          <template v-slot:item.acoes="{ item }">
            <div class="d-flex ga-1">
              <v-btn
                color="primary"
                size="small"
                elevation="2"
                @click.stop="abrirDetalhe(item.idProjeto)"
                class="action-btn mr-2"
              >
                <v-icon size="18">mdi-eye-outline</v-icon>
                <v-tooltip activator="parent" location="top">
                  <span class="text-caption font-weight-medium"
                    >Ver detalhes</span
                  >
                </v-tooltip>
              </v-btn>
              <v-btn
                color="error"
                size="small"
                elevation="2"
                :loading="processandoExclusao"
                @click.stop="abrirExclusao(item)"
                class="action-btn"
              >
                <v-icon size="18">mdi-trash-can-outline</v-icon>
                <v-tooltip activator="parent" location="top">
                  <span class="text-caption font-weight-medium"
                    >Excluir projeto</span
                  >
                </v-tooltip>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Cards para Mobile -->
      <div class="d-block d-md-none">
        <!-- Header Mobile -->
        <v-card class="mb-4 mobile-header-card" elevation="4">
          <v-card-title class="pa-4">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="d-flex align-center">
                <div class="mobile-icon-wrapper me-3">
                  <v-icon
                    icon="mdi-view-dashboard-outline"
                    size="28"
                    color="white"
                  ></v-icon>
                </div>
                <div>
                  <h2 class="text-h6 font-weight-bold text-white mb-1">
                    Projetos
                  </h2>
                  <p class="text-caption text-grey-lighten-2 ma-0">
                    {{ projetosFiltrados.length }} projeto{{
                      projetosFiltrados.length !== 1 ? "s" : ""
                    }}
                    encontrado{{ projetosFiltrados.length !== 1 ? "s" : "" }}
                  </p>
                </div>
              </div>
              <v-chip
                color="white"
                variant="elevated"
                prepend-icon="mdi-chart-box-outline"
                text-color="primary"
                size="small"
              >
                {{ projetosFiltrados.length }}
              </v-chip>
            </div>
          </v-card-title>
        </v-card>

        <!-- Loading Mobile -->
        <v-card v-if="carregando" class="pa-8 text-center loading-card">
          <div class="loading-icon-wrapper mx-auto mb-4">
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
              width="6"
            ></v-progress-circular>
          </div>
          <p class="text-h6 text-primary font-weight-medium mb-2">
            Carregando projetos...
          </p>
          <p class="text-body-2 text-medium-emphasis">Aguarde um momento</p>
        </v-card>

        <!-- Estado Vazio Mobile -->
        <v-card
          v-else-if="!projetosFiltrados.length"
          class="pa-8 text-center empty-state-card"
        >
          <div class="empty-icon-wrapper mx-auto mb-4">
            <v-icon
              icon="mdi-folder-search-outline"
              size="80"
              color="primary"
              class="empty-icon"
            ></v-icon>
          </div>
          <h3 class="text-h6 text-primary font-weight-bold mb-2">
            Nenhum projeto encontrado
          </h3>
          <p class="text-body-2 text-medium-emphasis mb-4">
            Tente ajustar os filtros ou cadastrar um novo projeto
          </p>
          <v-btn
            color="primary"
            variant="elevated"
            prepend-icon="mdi-plus-circle"
            @click="$router.push({ name: 'gestao-projetos.novo' })"
          >
            Criar Projeto
          </v-btn>
        </v-card>

        <!-- Cards dos Projetos -->
        <div v-else class="d-flex flex-column ga-3">
          <v-card
            v-for="projeto in projetosFiltrados"
            :key="`mobile-${projeto.idProjeto}`"
            elevation="4"
            @click="abrirDetalhe(projeto.idProjeto)"
            class="cursor-pointer project-card"
            hover
          >
            <v-card-title class="pb-2">
              <div class="d-flex align-center justify-space-between w-100">
                <div class="flex-grow-1 me-3">
                  <div class="text-body-1 font-weight-medium text-primary mb-1">
                    {{ projeto.titulo }}
                  </div>
                  <div class="d-flex ga-2">
                    <v-chip
                      v-if="projeto.nivelSaude"
                      size="x-small"
                      :color="getNivelSaudeColor(projeto.nivelSaude)"
                      variant="flat"
                      prepend-icon="mdi-heart"
                    >
                      {{ projeto.nivelSaude }}
                    </v-chip>
                    <v-chip
                      :color="getPrioridadeColor(projeto.prioridade)"
                      size="x-small"
                      variant="outlined"
                      :prepend-icon="getPrioridadeIcon(projeto.prioridade)"
                    >
                      {{ projeto.prioridade || "Sem prioridade" }}
                    </v-chip>
                  </div>
                </div>
                <div class="d-flex flex-column ga-1 align-self-start">
                  <v-btn
                    icon
                    variant="elevated"
                    color="primary"
                    size="small"
                    elevation="3"
                    @click.stop="abrirDetalhe(projeto.idProjeto)"
                    class="mobile-action-btn"
                  >
                    <v-icon size="20">mdi-eye-outline</v-icon>
                    <v-tooltip activator="parent" location="left">
                      <span class="text-caption font-weight-medium"
                        >Ver detalhes</span
                      >
                    </v-tooltip>
                  </v-btn>
                  <v-btn
                    icon
                    variant="elevated"
                    color="error"
                    size="small"
                    elevation="3"
                    :loading="processandoExclusao"
                    @click.stop="abrirExclusao(projeto)"
                    class="mobile-action-btn"
                  >
                    <v-icon size="20">mdi-trash-can-outline</v-icon>
                    <v-tooltip activator="parent" location="left">
                      <span class="text-caption font-weight-medium"
                        >Excluir</span
                      >
                    </v-tooltip>
                  </v-btn>
                </div>
              </div>
            </v-card-title>

            <v-card-text class="pt-0">
              <!-- Informações do Projeto -->
              <v-row dense class="mb-3">
                <v-col cols="12">
                  <div class="d-flex align-center mb-2">
                    <v-icon
                      icon="mdi-map-marker"
                      size="small"
                      class="me-2 text-medium-emphasis"
                    ></v-icon>
                    <span class="text-body-2">{{
                      projeto.nomeMunicipio || "—"
                    }}</span>
                  </div>
                  <div class="d-flex align-center">
                    <v-icon
                      icon="mdi-identifier"
                      size="small"
                      class="me-2 text-medium-emphasis"
                    ></v-icon>
                    <span class="text-body-2"
                      >ID PDM: {{ projeto.idPdm || "—" }}</span
                    >
                  </div>
                </v-col>
              </v-row>

              <!-- Status e Cronograma -->
              <div class="d-flex flex-column ga-2">
                <v-chip
                  :color="getStatusColor(projeto.situacao)"
                  variant="elevated"
                  size="small"
                  :prepend-icon="getStatusIcon(projeto.situacao)"
                  class="align-self-start"
                >
                  {{ projeto.situacao || "Não definido" }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>

      <!-- Erro -->
      <v-alert
        v-if="erro"
        type="error"
        variant="elevated"
        class="mb-4"
        :text="erro"
        closable
        @click:close="erro = ''"
      ></v-alert>
    </v-container>

    <!-- Modal de Exclusão com Vuetify -->
    <v-dialog v-model="exibindoExclusao" max-width="500" persistent>
      <v-card>
        <v-card-title class="d-flex align-center text-h6">
          <v-icon icon="mdi-alert-circle" color="error" class="me-2"></v-icon>
          Excluir Projeto
        </v-card-title>

        <v-card-text>
          <p class="mb-3">
            Confirme a exclusão do projeto
            <strong class="text-primary">{{
              projetoSelecionado ? projetoSelecionado.titulo : ""
            }}</strong
            >.
          </p>
          <v-alert
            type="warning"
            variant="outlined"
            density="compact"
            text=""
            class="mb-3"
            >Esta ação não poderá ser desfeita.</v-alert
          >

          <v-alert
            v-if="mensagemExclusao"
            type="error"
            variant="elevated"
            density="compact"
          >
            {{ mensagemExclusao }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="justify-end pa-4">
          <v-btn
            variant="text"
            @click="fecharExclusao"
            :disabled="processandoExclusao"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            variant="elevated"
            :loading="processandoExclusao"
            @click="confirmarExclusao"
          >
            Confirmar Exclusão
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComboboxMunicipio from "@/modules/city/components/ComboboxSingle.vue";
import { AREAS_CHAVE_GESTAO_MUNICIPAL } from "../constants/areasChave";
import { buscarOpcoes, buscarProjetos, excluirProjeto } from "../services/api";

export default {
  name: "ListaProjetosGestao",
  components: {
    ComboboxMunicipio,
  },
  data() {
    return {
      carregando: false,
      erro: "",
      projetos: [],
      projetosFiltrados: [],
      busca: "",
      filtros: {
        idMunicipio: undefined,
        situacao: "",
        areaChave: "",
      },
      opcoes: {
        situacoes: [],
      },
      areasChave: AREAS_CHAVE_GESTAO_MUNICIPAL,
      municipioFiltro: {
        municipio: null,
      },
      exibindoExclusao: false,
      projetoSelecionado: null,
      processandoExclusao: false,
      mensagemExclusao: "",
      // Headers para o v-data-table
      headers: [
        { text: "Projeto", value: "titulo", width: "35%", sortable: true },
        {
          text: "Município",
          value: "nomeMunicipio",
          width: "25%",
          sortable: true,
        },
        {
          text: "Prioridade",
          value: "prioridade",
          width: "15%",
          sortable: true,
        },
        { text: "Status", value: "situacao", width: "15%", sortable: true },
        { text: "Ações", value: "acoes", width: "10%", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["uf"]),
  },
  async created() {
    await this.carregarOpcoes();
    this.tentarSincronizarMunicipio();
    await this.carregarProjetos();
  },
  watch: {
    filtros: {
      deep: true,
      handler() {
        this.carregarProjetos();
      },
    },
    "filtros.idMunicipio": {
      handler() {
        this.$nextTick(() => this.tentarSincronizarMunicipio());
      },
    },
  },
  methods: {
    async carregarOpcoes() {
      try {
        const { data } = await buscarOpcoes(this.uf);
        this.opcoes = {
          situacoes: data.situacoes || [],
        };
      } catch (error) {
        this.erro = "Falha ao carregar filtros.";
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] opcoes-lista", error);
      }
    },
    async carregarProjetos() {
      try {
        this.carregando = true;
        this.erro = "";
        console.log("Carregando projetos com filtros:", this.filtros);
        const { data } = await buscarProjetos(this.filtros);
        console.log("Dados recebidos:", data);
        console.log("Número de projetos:", data ? data.length : 0);
        this.projetos = data || [];
        this.filtrarLocal();
        console.log("Projetos filtrados:", this.projetosFiltrados);
      } catch (error) {
        this.erro = "Não foi possível carregar os projetos.";
        console.error("[gestao-projetos] projetos", error);
      } finally {
        this.carregando = false;
      }
    },
    aoAlterarMunicipio(municipio) {
      if (Array.isArray(municipio)) {
        const selecionado = municipio.find(
          (item) => item && (item.municipioId || item.id)
        );
        this.filtros.idMunicipio = selecionado
          ? Number(selecionado.municipioId || selecionado.id)
          : undefined;
      } else if (municipio && typeof municipio === "object") {
        this.filtros.idMunicipio =
          municipio.municipioId || municipio.id || undefined;
      } else {
        this.filtros.idMunicipio = municipio || undefined;
      }
      this.municipioFiltro.municipio =
        municipio && typeof municipio === "object" ? municipio : null;
    },
    tentarSincronizarMunicipio(tentativa = 0) {
      if (tentativa > 10) return;
      if (!this.filtros.idMunicipio) {
        this.municipioFiltro.municipio = null;
        return;
      }
      const combobox = this.$refs.filtroMunicipio;
      const lista = combobox?.municipios;
      if (Array.isArray(lista) && lista.length) {
        const encontrado = lista.find(
          (item) => item.municipioId === this.filtros.idMunicipio
        );
        if (encontrado) {
          this.municipioFiltro.municipio = encontrado;
          return;
        }
      }
      setTimeout(() => this.tentarSincronizarMunicipio(tentativa + 1), 200);
    },
    filtrarLocal() {
      const termo = this.busca.trim().toLowerCase();
      this.projetosFiltrados = !termo
        ? [...this.projetos]
        : this.projetos.filter((projeto) =>
            projeto.titulo?.toLowerCase().includes(termo)
          );
      console.log(
        "Filtro local aplicado. Projetos filtrados:",
        this.projetosFiltrados.length
      );
    },
    formatarData(valor) {
      if (!valor) return "—";
      return new Date(valor).toLocaleDateString("pt-BR");
    },
    getStatusIcon(situacao) {
      if (!situacao) return "mdi-help-circle";
      const status = situacao.toLowerCase();

      if (
        status.includes("concluído") ||
        status.includes("finalizado") ||
        status.includes("completo")
      ) {
        return "mdi-check-circle";
      }
      if (
        status.includes("andamento") ||
        status.includes("executando") ||
        status.includes("progresso")
      ) {
        return "mdi-play-circle";
      }
      if (
        status.includes("pausado") ||
        status.includes("suspenso") ||
        status.includes("interrompido")
      ) {
        return "mdi-pause-circle";
      }
      if (
        status.includes("planejado") ||
        status.includes("aguardando") ||
        status.includes("pendente")
      ) {
        return "mdi-clock-outline";
      }
      if (
        status.includes("cancelado") ||
        status.includes("arquivado") ||
        status.includes("descontinuado")
      ) {
        return "mdi-close-circle";
      }

      return "mdi-circle-outline";
    },
    getStatusColor(situacao) {
      if (!situacao) return "grey";
      const status = situacao.toLowerCase();

      if (
        status.includes("concluído") ||
        status.includes("finalizado") ||
        status.includes("completo")
      ) {
        return "success";
      }
      if (
        status.includes("andamento") ||
        status.includes("executando") ||
        status.includes("progresso")
      ) {
        return "primary";
      }
      if (
        status.includes("pausado") ||
        status.includes("suspenso") ||
        status.includes("interrompido")
      ) {
        return "warning";
      }
      if (
        status.includes("planejado") ||
        status.includes("aguardando") ||
        status.includes("pendente")
      ) {
        return "info";
      }
      if (
        status.includes("cancelado") ||
        status.includes("arquivado") ||
        status.includes("descontinuado")
      ) {
        return "error";
      }

      return "grey";
    },
    getPrioridadeColor(prioridade) {
      if (!prioridade) return "grey";
      const prio = prioridade.toLowerCase();

      if (prio.includes("alta")) return "error";
      if (prio.includes("média") || prio.includes("media")) return "warning";
      if (prio.includes("baixa")) return "success";

      return "grey";
    },
    getPrioridadeIcon(prioridade) {
      if (!prioridade) return "mdi-help-circle";
      const prio = prioridade.toLowerCase();

      if (prio.includes("alta")) return "mdi-arrow-up-bold";
      if (prio.includes("média") || prio.includes("media")) return "mdi-minus";
      if (prio.includes("baixa")) return "mdi-arrow-down-bold";

      return "mdi-circle-outline";
    },
    getNivelSaudeColor(nivel) {
      if (!nivel) return "grey";
      const saude = nivel.toLowerCase();

      if (saude.includes("saudavel") || saude.includes("saudável"))
        return "success";
      if (saude.includes("atencao") || saude.includes("atenção"))
        return "warning";
      if (saude.includes("critico") || saude.includes("crítico"))
        return "error";

      return "info";
    },
    abrirDetalhe(idProjeto) {
      this.$router.push({
        name: "gestao-projetos.detalhe",
        params: { idProjeto },
      });
    },
    abrirExclusao(projeto) {
      if (!projeto) return;
      this.projetoSelecionado = { ...projeto };
      this.exibindoExclusao = true;
      this.mensagemExclusao = "";
    },
    fecharExclusao() {
      this.exibindoExclusao = false;
      this.projetoSelecionado = null;
      this.mensagemExclusao = "";
    },
    async confirmarExclusao() {
      if (!this.projetoSelecionado || this.processandoExclusao) return;
      try {
        this.processandoExclusao = true;
        this.mensagemExclusao = "";
        await excluirProjeto(this.projetoSelecionado.idProjeto);
        this.$toasted && this.$toasted.success("Projeto excluído com sucesso!");
        this.fecharExclusao();
        await this.carregarProjetos();
      } catch (error) {
        this.$toasted &&
          this.$toasted.error("Não foi possível excluir o projeto.");
        this.mensagemExclusao =
          "Não foi possível excluir o projeto. Tente novamente em instantes.";
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] excluir projeto", error);
      } finally {
        this.processandoExclusao = false;
      }
    },
    limparFiltros() {
      this.busca = "";
      this.filtros = {
        idMunicipio: undefined,
        situacao: "",
        areaChave: "",
      };
      this.municipioFiltro.municipio = null;
    },
  },
};
</script>

<style scoped>
.lista-projetos {
  display: flex;
  flex-direction: column;
  gap: clamp(20px, 3vw, 32px);
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 0;
}

/* Fundo da listagem */
.lista-background {
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.05) 0%,
    rgba(147, 197, 253, 0.08) 25%,
    rgba(219, 234, 254, 0.05) 50%,
    rgba(252, 252, 252, 0.9) 100%
  );
  border-radius: 20px;
  position: relative;
}

.lista-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 20%,
      rgba(59, 130, 246, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 80%,
      rgba(147, 197, 253, 0.08) 0%,
      transparent 50%
    );
  border-radius: 20px;
  pointer-events: none;
}

/* Cards aprimorados */
.desktop-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(59, 130, 246, 0.1);
  border-radius: 16px !important;
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.05) !important;
  position: relative;
  overflow: hidden;
}

.desktop-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd);
}

/* Header do card */
.card-header {
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.02) 0%,
    rgba(219, 234, 254, 0.05) 100%
  );
  border-bottom: 1px solid rgba(59, 130, 246, 0.08);
}

.header-icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.header-icon {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  color: white !important;
}

.count-chip {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  font-weight: 600;
}

/* Mobile header */
.mobile-header-card {
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%) !important;
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.3) !important;
}

.mobile-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Estados especiais */
.loading-card {
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%) !important;
  border: 2px dashed rgba(59, 130, 246, 0.2);
  border-radius: 16px !important;
}

.loading-icon-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.1) 0%,
    rgba(219, 234, 254, 0.2) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state-card {
  background: linear-gradient(135deg, #ffffff 0%, #fefce8 100%) !important;
  border: 2px dashed rgba(251, 191, 36, 0.3);
  border-radius: 16px !important;
}

.empty-icon-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.1) 0%,
    rgba(219, 234, 254, 0.2) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-icon {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Cards dos projetos */
.project-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(59, 130, 246, 0.08);
  border-radius: 14px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.project-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.project-card:hover::before {
  transform: scaleX(1);
}

.project-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(59, 130, 246, 0.15),
    0 6px 20px rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(59, 130, 246, 0.2);
}

.topo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.topo h2 {
  margin: 0;
  font-size: clamp(1.4rem, 2vw, 1.65rem);
  color: #1f2937;
}

.topo p {
  margin: 4px 0 0;
  color: #64748b;
}

.botao-primario {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border-radius: 10px;
  background: #60a5fa;
  color: #0f172a;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 20px rgba(96, 165, 250, 0.2);
}

.botao-primario:hover,
.botao-primario:focus {
  background: #3b82f6;
  color: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(59, 130, 246, 0.24);
}

.filtros-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;
}

.filtros-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;
}

.filtros-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filtros-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.4;
}

.filtros-clear {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.filtros-clear:hover {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
}

.filtros-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: end;
  margin-bottom: 16px;
}

.filtros-grid-secondary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: end;
}

.filtro-campo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filtro-campo label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filtro-campo label svg {
  color: #0074cc;
}

.filtro-input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 0.95rem;
  color: #1f2937;
  background: #ffffff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-input:focus {
  outline: none;
  border-color: #0074cc;
  box-shadow: 0 0 0 3px rgba(0, 116, 204, 0.1);
}

.form-select {
  width: 100%;
  padding: 12px 16px;
  padding-right: 40px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 0.95rem;
  color: #1f2937;
  background: #ffffff;
  background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>');
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.form-select:focus {
  outline: none;
  border-color: #0074cc;
  box-shadow: 0 0 0 3px rgba(0, 116, 204, 0.1);
  background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%230074cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>');
}

.filtro-campo :deep(.combobox-municipio .v-input__control),
.filtro-campo :deep(.combobox-municipio .v-field) {
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.filtro-campo :deep(.combobox-municipio .v-field:hover) {
  border-color: #0074cc;
  box-shadow: 0 2px 6px rgba(0, 116, 204, 0.1);
}

.filtro-campo :deep(.combobox-municipio .v-field--focused) {
  border-color: #0074cc;
  box-shadow: 0 0 0 3px rgba(0, 116, 204, 0.1);
}

.filtro-campo :deep(.combobox-municipio .v-field__input) {
  padding: 12px 16px;
  font-size: 0.95rem;
}

.filtro-campo :deep(.combobox-municipio .v-field) {
  min-height: 48px;
}

.filtro-campo :deep(.combobox-municipio .v-field__input),
.filtro-campo :deep(.combobox-municipio input) {
  min-height: 48px;
  padding: 8px 16px;
}

.cursor-pointer {
  cursor: pointer;
}

/* Estilos para botões de ação */
.action-btn {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px !important;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.mobile-action-btn {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 10px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.mobile-action-btn:hover {
  transform: translateY(-1px) scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
}

.mobile-action-btn .v-icon {
  transition: transform 0.2s ease;
}

.mobile-action-btn:hover .v-icon {
  transform: scale(1.1);
}

/* Melhoria nos tooltips */
.v-tooltip .v-overlay__content {
  background: rgba(55, 65, 81, 0.95) !important;
  border-radius: 6px !important;
  backdrop-filter: blur(8px);
}

/* Override para o Vuetify se necessário */
:deep(.v-data-table__wrapper) {
  border-radius: 0;
}

:deep(.v-data-table-header__content) {
  font-weight: 600;
}

:deep(.v-chip) {
  font-weight: 500;
}

@media (max-width: 960px) {
  .topo {
    flex-direction: column;
    align-items: flex-start;
  }

  .botao-primario {
    width: 100%;
  }

  .filtros-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros-clear {
    align-self: flex-start;
  }

  .filtros-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .filtros-grid-secondary {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .filtros-container {
    padding: 16px;
  }

  .filtros-header h3 {
    font-size: 1.1rem;
  }

  .filtros-grid,
  .filtros-grid-secondary {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .filtros-container {
    padding: 14px;
  }
}
</style>
